import fetch from "../utils/fetch";
import React from "react";
import * as storage from "../utils/storage";
import { Route, withRouter, Switch } from "react-router-dom";


export const debug_processUser = ( userAsStruct ) =>
{
    if( userAsStruct )
    {
        if( userAsStruct.identifier && userAsStruct.identifier.match && userAsStruct.identifier.match( "@atollon.com" ))
        {
            storage.set('debug_enabled',1);
            return true;
        }
        else
        {
            storage.set('debug_enabled',0);
            return false;
        }
    }
    return false;
};

export const debug_isEnabled = () =>
{
    return + storage.get('debug_enabled');
    // let isLocal = window.location.href.match("localhost");
    // return isLocal;
};

export const debug_internet_get = async ( getUrl ) => {

    try {
        const response = await fetch( getUrl );

        if (response.status === 200) {

            const content = await response.json();

            console.log('debug_internet_get', getUrl, '200', content );

        } else if (
            (response.status === 401 || response.status === 403)
        ) {

            const url = await response.text();

            console.log('debug_internet_get', getUrl, '40x redirectTo',url);

        } else if (response.status === 500 || response.status === 503) {

            console.log('debug_internet_get', getUrl, '500', 'alertBackendError');
        }

        return response.status === 200;

    } catch (error) {

        console.log('debug_internet_get', getUrl, 'error', error, 'alertBackendError');

        return false;
    }
};

const InsertDebugStyle = () =>
{
    let enabled = + storage.get("debug_DebugElement_show");
    if(enabled) {
        return <style>{'.DebugElement{display:block}'}</style>
    } else {
        return <style></style>
    }
};


export const DebugElement = ({text}) => {
    if( debug_isEnabled()) {
        return (
            <div className="DebugElement" title={text}>
                <h3 className="DebugElement__title">{text}</h3>
                <InsertDebugStyle />
            </div>
        );
    }
    else
    {
        // do nothing
        return (
            <span></span>
        );
    }
};

export const DebugElementBegin = ({text}) => {
    if( debug_isEnabled()) {
        return (
            <div className="DebugElement DebugElementBegin" title={text}>
                <h3 className="DebugElement__title">{text}</h3>
                <InsertDebugStyle />
            </div>
        );
    }
    else
    {
        // do nothing
        return (
            <span></span>
        );
    }
};

export const DebugElementEnd = ({text,children}) => {
    if( debug_isEnabled()) {
        return (
            <div className="DebugElement DebugElementEnd" title={text}>
                <h3 className="DebugElement__title">{text}</h3>
                <InsertDebugStyle />
            </div>
        );
    }
    else
    {
        // do nothing
        return (
            <span></span>
        );
    }
};

var safeGetDictionaryValue = ( dict, keysArray, defaultValue ) =>
{
    var returnValue = defaultValue;
    var currentDict = dict;
    for( var keyIndex in keysArray )
    {
        debugger;
        var key = keysArray[keyIndex];
        if( currentDict.length !== undefined)
        {
            if( key in currentDict )
            {
                returnValue = currentDict[key];
                currentDict = currentDict[key];
            }
            else
            {
                break;
            }
        }
    }
    return returnValue;
};

export const DebugRoute = ( props ) => {
    if( debug_isEnabled())
    {
        return (
            <div>
                <DebugElement text={props.path + ": " + (props.component && props.component.displayName)}/>
                <Route {...props} />
                <DebugElement text={props.path}/>
            </div>
        );
    }
    else
    {
        return (
            <Route {...props} />
        );
    }
};

window.debug_internet_get = debug_internet_get;



// WEBPACK FOOTER //
// ./src/Atollon/debug.js